module.exports = __webpack_public_path__ + "static/media/Table_Poster.c938134c.svg";